import { Dispatch, SetStateAction } from 'react';

import { required } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { Checkbox } from 'shared/mui/Checkbox/Checkbox';
import { FormControlLabel } from 'shared/mui/FormControlLabel/FormControlLabel';
import { TooltipWithInfoIcon } from 'shared/mui/Tooltip';
import { AutocompleteInput, BooleanInput, TextInput } from 'shared/react-admin/Inputs';
import { ReferenceInput } from 'shared/react-admin/ReferenceInputs';

import { BoxStyled } from './UsersCreateForm.styled';

type UsersFormProps = {
  hasCorporateEmail?: boolean;
  setHasCorporateEmail: Dispatch<SetStateAction<boolean>>;
};

export const UsersCreateForm: React.FC<UsersFormProps> = ({
  hasCorporateEmail,
  setHasCorporateEmail,
}) => {
  return (
    <BoxStyled>
      <BooleanInput
        defaultValue={true}
        label="Активен"
        name="enabled"
        size="small"
        source="enabled"
        sx={{ marginBottom: '24px', gridColumn: ' 1 / span 2' }}
        variant="outlined"
      />
      <TextInput
        fullWidth
        label="Имя"
        size="small"
        source="firstName"
        validate={required()}
        variant="outlined"
      />
      <TextInput
        fullWidth
        label="Фамилия"
        size="small"
        source="lastName"
        validate={required()}
        variant="outlined"
      />
      <TextInput
        fullWidth
        label="Reddy"
        size="small"
        source="reddyNumber"
        validate={required()}
        variant="outlined"
      />
      <TextInput
        fullWidth
        label="Электронная почта"
        size="small"
        source="email"
        variant="outlined"
      />
      <ReferenceInput perPage={200} reference="roles" source="roleEntities">
        <AutocompleteInput
          filterToQuery={(searchText: string) => ({ name: searchText })}
          format={(v) => v?.[0] || null}
          fullWidth
          label="Роль"
          optionText="name"
          parse={(v) => (v ? [v] : [])}
          size="small"
          source="roleEntities"
          sx={{ marginBottom: '4px', gridColumn: '1 / span 2' }}
          validate={required()}
          variant="outlined"
        />
      </ReferenceInput>
      <FormControlLabel
        control={
          <Checkbox
            checked={hasCorporateEmail}
            onChange={() => setHasCorporateEmail(!hasCorporateEmail)}
          />
        }
        label={
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            Групповой email
            <TooltipWithInfoIcon
              componentsProps={{ popper: { sx: { width: '247px' } } }}
              iconSize={24}
              tooltipText="Используется для отправки отчётов разных пользователей на один email."
            />
          </Box>
        }
        sx={{ marginBottom: '20px', gridColumn: ' 1 / span 2' }}
      />
      {hasCorporateEmail && (
        <TextInput
          fullWidth
          label="Групповой email"
          name="corporateEmail"
          size="small"
          source="corporateEmail"
          sx={{ gridColumn: ' 1 / span 2' }}
          variant="outlined"
        />
      )}
    </BoxStyled>
  );
};
